export default __webpack_public_path__ + "static/media/flag-botswana.cfc2b7a6.svg";